module.exports = "<div class=fab data-message=add-post> <button type=button class=\"button-alpha button-fab\" ng-click=handleClick() ng-disabled=disabled> <svg class=iconic> <use xlink:href=" + require("/var/app/node_modules/ushahidi-platform-pattern-library/assets/img/iconic-sprite.svg") + "#plus></use> <foreignObject> <img class=icon src=" + require("/var/app/node_modules/ushahidi-platform-pattern-library/assets/img/icons/png/plus-2x.png") + "> </foreignObject> </svg> <span class=hidden>Add</span> </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/views/add-post-button.html
// module id = 738
// module chunks = 0